<template>
	<button
		:disabled="buttonDisabled"
		class="btn btn-primary"
		:type="buttonType"
		:class="{
			'btn-primary--disabled': buttonDisabled,
		}"
		@click="handleClick"
	>
		{{ labelText }}
	</button>
</template>
<script>

export default {
	props: {
		labelText: {
			type: String,
			default: 'Continue',
		},
		buttonDisabled: {
			type: Boolean,
			default: false,
		},
		buttonType: {
			type: String,
			default: 'button',
		},
	},
	emits: ['buttonClick'],
	data() {
		return {
			selected: false,
		};
	},
	methods: {
		handleClick() {
			this.$emit('buttonClick');
		},
	},
};
</script>

<style scoped lang="scss">
// TODO: Refactor this to be in a .SCSS file
$text-color: #40474f;
$border-color: #d9dadc;
$wesleyan-gold: #FEBD11;
$disabled-text-color: #b3b5b9;
$button-disabled-border-color: #b3b5b9;

.btn {
	@media only screen and (max-width: 410px) {
		padding-right: 5px !important;
		padding-left: 5px !important;
		font-feature-settings: 'liga' off, 'clig' off;
		font-size: 17px;
	}
    &:hover {
        background-color: $text-color;
        color: white;
        border-color: $text-color;
    }

    &-primary--disabled {
        background-color: white;
        border-color: $border-color;
        color: $disabled-text-color;
        cursor: default;
        border-width: 2px;
        border-color: $button-disabled-border-color;
    }
}

</style>
